import { useNavigate } from "react-router-dom";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { PHASE_KEYS, PROJECT_STATUS } from "@/lib/workflow";

const GROUPS = {
  phase: { field: "lifecycle_phase", cols: PHASE_KEYS.filter((p) => p.value !== "all") },
  status: { field: "status", cols: PROJECT_STATUS.filter((s) => s.value !== "all") },
  erp: { field: "_erp", cols: [{ value: "ready", label: "ERP Ready" }, { value: "not_ready", label: "Not ready" }] },
};

export function BoardView({ projects, groupBy }) {
  const navigate = useNavigate();
  const cfg = GROUPS[groupBy] || GROUPS.phase;
  const keyOf = (p) => (groupBy === "erp" ? (p.erp_ready ? "ready" : "not_ready") : p[cfg.field]);
  const byCol = {};
  cfg.cols.forEach((c) => (byCol[c.value] = []));
  projects.forEach((p) => { const k = keyOf(p); if (byCol[k]) byCol[k].push(p); });

  return (
    <div className="mt-4 flex gap-3 overflow-x-auto pb-4" data-testid="projects-board-view">
      {cfg.cols.map((c) => (
        <div key={c.value} className="w-72 shrink-0 rounded-xl border border-slate-200 bg-slate-50/70" data-testid={`board-col-${c.value}`}>
          <div className="px-3 py-2.5 border-b border-slate-200 flex items-center justify-between">
            <span className="text-sm font-semibold text-slate-800">{c.label}</span>
            <Badge variant="outline" className="bg-white text-xs">{byCol[c.value].length}</Badge>
          </div>
          <div className="p-2 space-y-2 min-h-[80px]">
            {byCol[c.value].map((p) => (
              <button key={p.project_id} onClick={() => navigate(`/projects/${p.project_id}`)} data-testid={`board-card-${p.project_number}`}
                className="w-full text-left rounded-lg border border-slate-200 bg-white p-3 hover:border-slate-900 hover:shadow-sm transition">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-xs text-slate-500">{p.project_number}</span>
                  {p.blocked && <Badge className="bg-red-100 text-red-700 text-[10px]">Blocked</Badge>}
                </div>
                <div className="mt-1 text-sm font-medium text-slate-900 truncate">{p.customer_name}</div>
                <div className="text-xs text-slate-500 truncate">{p.brand} · {p.project_type}</div>
                <div className="mt-2 flex items-center gap-2">
                  <Progress value={p.readiness_pct || 0} className="h-1.5 flex-1" />
                  <span className="text-[10px] text-slate-500">{p.readiness_pct || 0}%</span>
                </div>
              </button>
            ))}
            {byCol[c.value].length === 0 && <p className="text-xs text-slate-400 text-center py-4">—</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
